import React, { useEffect, useState } from "react";
import { Box, Typography, Container, CircularProgress } from '@mui/material';
import CardFeatures from "../elements/pages/Main/CardFeatures";
import { collection, onSnapshot } from "firebase/firestore";
import { db } from "../firebase/firebaseConfig";

const Features = () => {
    const [caracteristicaProducto, setCaracteristicaProducto] = useState([]);
    const [loading, setLoading] = useState(true);
    const [currentIndex, setCurrentIndex] = useState(0);

    // Función para truncar el texto
    const truncateText = (text, maxLength = 300) => {
        return text.length > maxLength ? text.slice(0, maxLength) + '...' : text;
    }

    useEffect(() => {
        onSnapshot(collection(db, 'infocaracteristicaproductocalocho'),
            (snapshot) => {
                const arregloCaracteristicaProducto = snapshot.docs.map((docCaracteristicaProducto) => {
                    return {...docCaracteristicaProducto.data(), id: docCaracteristicaProducto.id};
                })

                setCaracteristicaProducto(arregloCaracteristicaProducto);
                setLoading(false); // Data has been loaded
            },
            (error) => {
                console.log(error);
            }
        );
    }, []);

    // Carrusel: Actualizar el índice cada 10 segundos
    useEffect(() => {
        if (caracteristicaProducto.length > 1) {
            const interval = setInterval(() => {
                setCurrentIndex((prevIndex) => (prevIndex + 1) % caracteristicaProducto.length);
            }, 10000); // 10000ms = 10s
            return () => clearInterval(interval);
        }
    }, [caracteristicaProducto.length]);

    if (loading) {
        return (
          <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
              <CircularProgress sx={{ color: '#5d0303' }} />
          </Box>
        );
    }

    if (caracteristicaProducto.length === 0) {
        return (
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
                <Typography variant="h6">No hay datos por mostrar</Typography>
            </Box>
        );
    }

    return(
        caracteristicaProducto.length > 0 &&
        <Box
            sx={{
                backgroundImage: 'linear-gradient(180deg, #5d0303, #8E0505)', // Fondo oscuro similar al mostrado en la imagen
                padding: { xs: '20px', md: '50px' }, // Ajuste de padding para diferentes tamaños de pantalla
                color: '#fff',
                minHeight: '100vh', // Asegura que el contenedor cubra toda la pantalla            
            }}
        >
            <Container 
                key={caracteristicaProducto[currentIndex].id}
                sx={{
                    padding: { xs: 2, sm: 4, md: 6 },  // Padding ajustado para diferentes pantallas
                    maxWidth: { xs: '100%', sm: '80%', md: '70%' },  // Ancho dinámico
                }}
            >
                <Typography
                        variant="h4"
                        align="center"
                        gutterBottom
                        sx={{
                            fontWeight: 'bold',
                            fontSize: { xs: '1.5rem', sm: '2rem', md: '2.5rem' },
                            margin: { xs: '12px 0', sm: '18px 0' },
                            textAlign: 'center',
                        }}
                    >
                        {caracteristicaProducto[currentIndex].titulo}
                    </Typography>
                    <Typography
                        variant="subtitle2"
                        align="center"
                        gutterBottom
                        sx={{
                            fontSize: { xs: '1rem', sm: '1.2rem' },
                            margin: { xs: '10px 0', sm: '15px 0' },
                            textAlign: 'center',
                        }}
                    >
                        <span>{truncateText(caracteristicaProducto[currentIndex].descripcion)}</span>
                    </Typography>
                    <CardFeatures />
            </Container>
        </Box>
    );
}

export default Features;